var chunkMapping = {
	"5228": [
		75228
	],
	"6179": [
		62797,
		88296,
		93947
	],
	"7126": [
		4446,
		17418,
		49394,
		85646
	],
	"7293": [
		7293
	],
	"8165": [
		29870,
		31930,
		47538,
		51113,
		82893,
		89982
	],
	"8186": [
		99406
	]
};
var idToExternalAndNameMapping = {
	"4446": [
		"default",
		"./utils/common",
		88569
	],
	"7293": [
		"default",
		"./AppLoader",
		88569
	],
	"17418": [
		"default",
		"./appSlice",
		88569
	],
	"29870": [
		"default",
		"./helpers/PageTitle",
		88569
	],
	"31930": [
		"default",
		"./components/CustomNoDataOverlay",
		88569
	],
	"47538": [
		"default",
		"./helpers/CustomModalStyle",
		88569
	],
	"49394": [
		"default",
		"./store",
		88569
	],
	"51113": [
		"default",
		"./helpers/PageContainer",
		88569
	],
	"62797": [
		"default",
		"./components/ColumnSelectorStyle",
		88569
	],
	"75228": [
		"default",
		"./utils/constants",
		88569
	],
	"82893": [
		"default",
		"./helpers/PageSubHeader",
		88569
	],
	"85646": [
		"default",
		"./headerSlice",
		88569
	],
	"88296": [
		"default",
		"./helpers/CustomSearch",
		88569
	],
	"89982": [
		"default",
		"./helpers/Breadcrumb",
		88569
	],
	"93947": [
		"default",
		"./helpers/CustomDropDownSelect",
		88569
	],
	"99406": [
		"default",
		"./providers/FlagsmithProvider",
		88569
	]
};
var idToRemoteMap = {
	"4446": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"7293": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"17418": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"29870": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"31930": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"47538": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"49394": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"51113": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"62797": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"75228": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"82893": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"85646": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"88296": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"89982": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"93947": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	],
	"99406": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 88569
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}